import * as React from 'react';
import Svg, {Path, SvgProps} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={29}
    height={30}
    viewBox="0 0 29 30"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#fff'}
      fillRule="evenodd"
      d="M8.42 6.399c3.03-2.01 4-2.6 4.98-2.81.82-.18 1.68-.18 2.5 0 .98.21 1.94.8 4.98 2.81 2.7 1.78 3.52 2.37 4.06 3.09.46.61.8 1.3 1 2.04.24.87.2 1.88-.04 5.12-.17 2.39-.29 4.03-.49 5.29-.19 1.23-.43 1.89-.72 2.36-.57.93-1.38 1.68-2.34 2.18-.5.26-1.17.44-2.41.55-1.27.11-2.91.11-5.3.11-2.39 0-4.03 0-5.3-.11-1.24-.1-1.91-.29-2.41-.55a5.85 5.85 0 0 1-2.34-2.18c-.29-.48-.53-1.13-.72-2.36-.2-1.26-.32-2.9-.49-5.29-.23-3.24-.27-4.25-.04-5.12.2-.74.54-1.43 1-2.04.55-.72 1.37-1.3 4.07-3.09h.01ZM.86 16.819c-.22-3.05-.33-4.58.04-5.96.28-1.05.77-2.04 1.43-2.91.87-1.14 2.14-1.98 4.68-3.67 2.86-1.89 4.29-2.84 5.84-3.17 1.18-.26 2.4-.26 3.58 0 1.55.34 2.98 1.28 5.84 3.17 2.54 1.68 3.81 2.52 4.68 3.67.66.87 1.15 1.86 1.43 2.91.37 1.39.26 2.91.04 5.96-.34 4.7-.51 7.05-1.58 8.8a8.472 8.472 0 0 1-3.34 3.11c-1.82.94-4.17.94-8.87.94-4.7 0-7.04 0-8.87-.94a8.405 8.405 0 0 1-3.34-3.11c-1.07-1.75-1.24-4.1-1.58-8.8h.02Zm10.62 3.76a1.06 1.06 0 0 0 0 2.12h6.34a1.06 1.06 0 0 0 0-2.12h-6.34Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default SvgComponent;
